import localTranslations from './local-translations.json';

export type Locale = 'EN' | 'FR';

export type Translations = Record<Locale, Record<string, string>>;

export const translations: Translations = {
    ...localTranslations,
};
